<template>
  <section class="organisers">
    <div class="row">
      <div
        v-for="(organiser, idx) in organisers"
        :key="idx"
        class="col-sm-6 mb-4"
      >
        <BCard class="organiser">
          <BCardText>
            <CertificationFormGroup :name="`organizations.$each.${idx}.generalError`">
              <template slot-scope="{validator}">
                <InputHiddenControl id="'organiser-general-' + idx"/>
              </template>
            </CertificationFormGroup>

            <CertificationFormGroup
              :name="`organizations.$each.${idx}.name`"
              :can-moderate="false"
            >
              <template slot-scope="{ validator }">
                <OrganizationTypeAheadControl
                  id="'organiser-name-' + idx"
                  v-model="organiser.name"
                  label="Nazwa organizatora"
                  :disabled="disabled"
                  :min-length="2"
                  zzzinput="$parent.touch(validator)"
                  @update:value="organiser.id = $event"
                />
              </template>
            </CertificationFormGroup>

            <CertificationFormGroup :name="`organizations.$each.${idx}.type`">
              <template slot-scope="{ validator }">
                <SelectControl
                  :id="'organiser-type-' + idx"
                  v-model="organisers[idx].type"
                  :options="organizationType"
                  :get-object="false"
                  :disabled="disabled"
                  label="Typ organizatora"
                  help="<p><strong>Organizator logistyczny</strong> – podmiot organizujący wydarzenie, odpowiedzialny za sferę logistyczną lub organizacyjną, w tym PCO lub HCO.</p>
              <p><strong>Organizator merytoryczny</strong> – podmiot organizujący wydarzenie, odpowiedzialny za sferę merytoryczną, w tym PCO lub HCO.</p>"
                  zzzinput="$parent.touch(validator)"
                />
              </template>
            </CertificationFormGroup>

            <transition name="slide-fade">
              <CertificationFormGroup
                v-show="organiser.type == 'essential'"
                :name="`organizations.$each.${idx}.nonBusiness`"
              >
                <template slot-scope="{ validator }">
                  <TrueFalseControl
                    :id="'organiser-business-' + idx"
                    v-model="organisers[idx].nonBusiness"
                    label="Organizator merytoryczny jest osobą fizyczną lub osobą fizyczną prowadzącą działalność gospodarczą"
                    :inline="false"
                    :disabled="disabled"
                    zzzinput="$parent.touch(validator)"
                  />
                </template>
              </CertificationFormGroup>
            </transition>

            <transition name="slide-fade">
              <CertificationFormGroup
                v-show="organisers[idx].type == 'logistic'"
                :name="`organizations.$each.${idx}.authorized`"
              >
                <template slot-scope="{ validator }">
                  <TrueFalseControl
                    :id="'organiser-authorized-' + idx"
                    v-model="organisers[idx].authorized"
                    label="Organizator logistyczny działa z upoważnienia organizatora merytorycznego "
                    :inline="false"
                    :disabled="disabled"
                    zzzinput="$parent.touch(validator)"
                  />
                </template>
              </CertificationFormGroup>
            </transition>
          </BCardText>
          <Btn
            v-if="(organisers.length > 0 || idx > 0) && !disabled"
            variant="outline-danger"
            size="sm"
            icon="user-minus"
            @click="removeOrganiser(idx)"
          >
            Usuń
          </Btn>
        </BCard>
      </div>
      <div v-if="!disabled" class="col-sm-6">
        <Btn variant="outline-primary" icon="user-plus" @click="addOrganiser">
          Dodaj kolejnego organizatora
        </Btn>
        <BaseControlHelp
          id="addOrganiser"
          name="question-circle"
          help="Należy podać wszystkich organizatorów logistycznych i merytorycznych"
        />
      </div>
    </div>
  </section>
</template>

<script>
import OrganizationTypeAheadControl from "@/components/Controls/OrganizationTypeAheadControl";
import BaseFormControl from "@/components/Base/Form/BaseFormControl";

import TrueFalseControl from "@/components/Controls/TrueFalseControl";
import SelectControl from "@/components/Controls/SelectControl";
import BaseControlHelp from "@/components/Base/Elements/BaseControlHelp";
import InputHiddenControl from '@/components/Controls/InputHiddenControl';
import { organizationType } from "./data";
import OrganizationModel from "@/model/Organization";

export default {
  name: "CertificationFormOrganisers",
  components: {
    OrganizationTypeAheadControl,
    TrueFalseControl,
    SelectControl,
    BaseControlHelp,
    InputHiddenControl
  },
  extends: BaseFormControl,
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      organisers: this.value,
      organizationType
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      this.organisers = newValue;
    }
  },
  methods: {
    addOrganiser() {
      this.organisers.push(new OrganizationModel());
    },
    removeOrganiser(idx) {
      this.organisers = this.organisers.filter((item, key) => key !== idx);
      this.$emit("input", this.organisers);
    }
  }
};
</script>

<style scoped></style>
